<template>
    <div v-if="visible" class="float-window" @mouseover="clearFdAd" @mouseout="starFdAd" :style="{
        left: `${left}px`,
        top: `${top}px`
    }">
        <div class="float-window-close" @click.prevent="close">
            <i class="el-icon-close"></i>
        </div>
        <div class="float-window-content" @click="baywindowsViewDetails">
            <div class="icon-wrapper">
                <img @dragstart.prevent :src="image" :bayid="bayid" :bayzd="bayzd" :baytype="baytype" alt="">
            </div>
            <div class="text-wrapper">
                <div class="baywindowstitle">{{bayzd}}</div>
            </div>
        </div>
    </div>
</template>
   
<script>
export default {
    name: 'bayWindow',
    props: {
        image: {
            type: String,
            required: true
        },
        speed: {
            type: Number,
            default: 1000 / 60
        },
        bayid:{
            type: String,
            required: true
        },
        bayzd:{
            type: String,
            required: true
        },
        baytype:{
            type: String,
            required: true
        }
    },
    data() {
        return {
            visible: false,
            top: 0,
            left: 0,
            maxX: 0,
            maxY: 0,
            directionX: -1,
            directionY: -1,
            floatWidth: 280,
            floatHeight: 80
        }
    },
    mounted() {
        this.setup()
        this.top = window.innerHeight - this.floatHeight - 50
        this.left = window.innerWidth - this.floatWidth - 20
        this.visible = true
        window.addEventListener('resize', this.setup)
        this.start()
    },
    destroyed() {
        this.close()
    },
    methods: {
        baywindowsViewDetails(){
            // console.log(this.$props.baytype)
            if(this.$props.baytype==7){
                this.$router.push("/PolicyCalculation/PolicyDetails/" + this.$props.bayid);
            }else if(this.$props.baytype==9){
                this.$router.push("/PolicyCalculation/policyInterpretationDeteils/" + this.$props.bayid);
            }
        },
        starFdAd() {
            this.timer = setInterval(this.move, this.speed)
        },
        clearFdAd() {
            clearInterval(this.timer)
        },
        /**
         * 配置
         */
        setup() {
            this.maxX = window.innerWidth - this.floatWidth // X轴边界
            this.maxY = window.innerHeight - this.floatHeight // Y轴边界
        },
        /**
         * 开始移动
         */
        start() {
            this.timer = setInterval(this.move, this.speed)
        },
        /**
         * 停止移动
         */
        stop() {
            clearInterval(this.timer)
        },
        /**
         * 移动飘窗
         */
        move() {
            const rect = this.$el.getBoundingClientRect()
            if (rect.x >= this.maxX) {
                this.directionX = -1
            } else if (rect.x <= 0) {
                this.directionX = 1
            }
            if (rect.y >= this.maxY) {
                this.directionY = -1
            } else if (rect.y <= 0) {
                this.directionY = 1
            }
            this.left += this.directionX
            this.top += this.directionY
        },
        /**
         * 关闭飘窗
         */
        close() {
            this.visible = false
            window.removeEventListener('resize', this.setup)
            clearInterval(this.timer)
        }
    }
}
</script>
   
<style scoped>
/* 长方形浮窗样式 - 2024更新 */
.float-window {
    display: block;
    transform: translateZ(0);
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 999999;
    width: 280px;
    height: 80px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.float-window:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}

.float-window-close {
    position: absolute;
    width: 24px;
    height: 24px;
    top: 8px;
    right: 8px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 10;
    backdrop-filter: blur(10px);
}

.float-window-close:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: rotate(90deg) scale(1.1);
}

.float-window-close i {
    font-size: 14px;
    color: #ffffff;
    font-weight: bold;
}

.float-window-content {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 12px 16px;
    cursor: pointer;
}

.icon-wrapper {
    flex-shrink: 0;
    width: 56px;
    height: 56px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
}

.float-window:hover .icon-wrapper {
    transform: scale(1.05);
}

.icon-wrapper img {
    width: 40px;
    height: 40px;
    display: block;
    object-fit: contain;
}

.text-wrapper {
    flex: 1;
    margin-left: 14px;
    overflow: hidden;
}

.baywindowstitle {
    color: #ffffff;
    font-size: 15px;
    font-weight: 500;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
</style>